module.exports = __webpack_public_path__ + "media/v2/components/Blog/shared/Pagination/img/arrow_top-85d1240ebed26b0e19470ad956fb9c8c.svg";